(function() {
    const inject = () => {
      const formEmbed = document.querySelector('#sidebar-menu');           
      const drawer = document.querySelector('.drawer.drawer-menu-custom');           
      
      const elementsToStyle = [
        { el: formEmbed, cssUrl: window.formCss },
        { el: drawer, cssUrl: window.drawerCss }
      ];

      elementsToStyle.forEach(item => {
        const el = item.el;
        if (el && el.shadowRoot) {
          // Avoid double injection
          if (!el.shadowRoot.querySelector('#style-link')) {
            const styleLink = document.createElement('link');
            styleLink.id = "style-link";
            styleLink.rel = "stylesheet";
            styleLink.href = item.cssUrl;
            styleLink.type = "text/css";
            el.shadowRoot.appendChild(styleLink);
          }
        }
      });

      let formEmbedDone = !formEmbed || (formEmbed.shadowRoot && formEmbed.shadowRoot.querySelector('#style-link'));
      let drawerDone = !drawer || (drawer.shadowRoot && drawer.shadowRoot.querySelector('#style-link'));
      return ((formEmbed || drawer) && formEmbedDone && drawerDone);
    };

    let attempts = 0;
    const intervalId = setInterval(() => {
      attempts++;
      if (inject() || attempts >= 15) {
        clearInterval(intervalId);
      }
    }, 1000);

    document.addEventListener('shopify:section:load', inject);
    document.addEventListener('shopify:theme:editor:load', inject);
  })();

  (function() {
    const inject = () => {
      const popConvert = document.querySelector('#pop-convert-app');           
      if (popConvert && popConvert.shadowRoot) {
        if (!popConvert.shadowRoot.querySelector('#style-link')) {
          const styleLink = document.createElement('link');
          styleLink.id = "style-link";
          styleLink.rel = "stylesheet";
          styleLink.href = window.popConvertCss;
          styleLink.type = "text/css";
          popConvert.shadowRoot.appendChild(styleLink);
        }
        return true;
      }
      return false;
    };

    let attempts = 0;
    const intervalId = setInterval(() => {
      attempts++;
      if (inject() || attempts >= 30) {
        clearInterval(intervalId);
      }
    }, 1000);

    document.addEventListener('shopify:section:load', inject);
    document.addEventListener('shopify:theme:editor:load', inject);
  })();



  class scrollingToggleSection extends HTMLElement {
    connectedCallback() {
      // Initial check on load
      this.checkVisibility();

      this.addEventListener('click', (event) => {
        const scrollingTarget = event.target.closest('.js-scrolling-section');

        if (scrollingTarget) {
          const sectionValue = this._getSectionValue(scrollingTarget);

          if (sectionValue) {
            const allScrollingTargets = document.querySelectorAll('[data-scrolling-main-section]');
            const mainSections = Array.from(allScrollingTargets).filter(el => 
              el.getAttribute('data-scrolling-main-section').trim() === sectionValue
            );
            
            if (mainSections.length > 0) {
              mainSections.forEach(section => {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
              });
            } else {
              const allToggleTargets = document.querySelectorAll('[data-main-toggle-text]');
              const toggleSections = Array.from(allToggleTargets).filter(el => 
                el.getAttribute('data-main-toggle-text').trim() === sectionValue
              );

              if (toggleSections.length > 0) {
                scrollingTarget.classList.toggle('is-active');
                toggleSections.forEach(section => {
                  section.classList.toggle('hide');
                });
              }
            }
          }
        }
      });
    }

    checkVisibility() {
      const triggers = this.querySelectorAll('.js-scrolling-section');
      let visibleCount = 0;

      triggers.forEach(trigger => {
        const sectionValue = this._getSectionValue(trigger);
        const parentBlock = trigger.closest('.product-info__block-item');

        if (!sectionValue || !this._hasTarget(sectionValue)) {
          trigger.classList.add('hide');
          if (parentBlock) parentBlock.classList.add('hide');
        } else {
          trigger.classList.remove('hide');
          if (parentBlock) parentBlock.classList.remove('hide');
          visibleCount++;

          if (this._isToggleTarget(sectionValue)) {
            trigger.classList.add('is-toggle');
            document.querySelector('.js-custom_bg_desktop').classList.add('apply_before_gradiant');
          } else {
            trigger.classList.remove('is-toggle');
            document.querySelector('.js-custom_bg_desktop').classList.remove('apply_before_gradiant');
          }
        }
      });

      // Update the parent group's visual classes to fix separators
      const parentGroup = this.closest('.redirect-tabs-group');
      if (parentGroup) {
        const blocks = Array.from(parentGroup.querySelectorAll('.product-info__block-item'));
        const visibleBlocks = blocks.filter(b => !b.classList.contains('hide'));

        blocks.forEach(b => b.classList.remove('is-first-visible', 'is-last-visible'));
        if (visibleBlocks.length > 0) {
          visibleBlocks[0].classList.add('is-first-visible');
          visibleBlocks[visibleBlocks.length - 1].classList.add('is-last-visible');
        }
      }

      // If no triggers are visible in this component, hide the component itself
      if (visibleCount === 0) {
        this.classList.add('hide');
      } else {
        this.classList.remove('hide');
      }
    }

    _getSectionValue(trigger) {
      const attrValue = trigger.getAttribute('data-scrolling-section');
      return (attrValue ? attrValue.trim() : trigger.textContent.trim());
    }

    _hasTarget(value) {
      if (!value) return false;

      const scrollingTargets = document.querySelectorAll(`[data-scrolling-main-section]`);
      const hasScrollingMatch = Array.from(scrollingTargets).some(el => 
        el.getAttribute('data-scrolling-main-section').trim() === value
      );

      if (hasScrollingMatch) return true;

      return this._isToggleTarget(value);
    }

    _isToggleTarget(value) {
      if (!value) return false;

      const toggleTargets = document.querySelectorAll(`[data-main-toggle-text]`);
      const hasToggleMatch = Array.from(toggleTargets).some(el => 
        el.getAttribute('data-main-toggle-text').trim() === value
      );

      return hasToggleMatch;
    }
  }

  customElements.define('scrolling-toggle-section', scrollingToggleSection);

// os js 
document.addEventListener('DOMContentLoaded', function () {
  var ua = navigator.userAgent.toLowerCase();
  var body = document.body;

  /* OS */
  if (/android/.test(ua)) body.classList.add('os-android');
  else if (/iphone|ipod/.test(ua)) body.classList.add('os-ios');
  else if (/ipad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    body.classList.add('os-ipados');
  else if (/windows/.test(ua)) body.classList.add('os-windows');
  else if (/mac os/.test(ua)) body.classList.add('os-macos');

  /* Browser */
  function addBrowser() {
    if (ua.indexOf('edg') > -1) body.classList.add('browser-edge');
    else if (ua.indexOf('opr') > -1 || ua.indexOf('opera') > -1) body.classList.add('browser-opera');
    else if (ua.indexOf('chrome') > -1) body.classList.add('browser-chrome');
    else if (ua.indexOf('firefox') > -1) body.classList.add('browser-firefox');
    else if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1)
      body.classList.add('browser-safari');
  }

  if (navigator.brave && navigator.brave.isBrave) {
    navigator.brave.isBrave().then(function (isBrave) {
      isBrave ? body.classList.add('browser-brave') : addBrowser();
    });
  } else {
    addBrowser();
  }
});

// js for collection shrt shadow root 

(function() {
  const inject = () => {
    const sortPopover = document.querySelector('#sort-by-popover');
    if (sortPopover && sortPopover.shadowRoot) {
      // Force the popover to stay relative to its parent even on mobile
      if (!Object.getOwnPropertyDescriptor(sortPopover, 'shouldAppendToBody')) {
        Object.defineProperty(sortPopover, 'shouldAppendToBody', { get: () => false });
        Object.defineProperty(sortPopover, 'shouldLock', { get: () => false });
      }

      const cssUrl = sortPopover.getAttribute('data-shadow-css');
      if (cssUrl && !sortPopover.shadowRoot.querySelector('#style-link-sort')) {
        const styleLink = document.createElement('link');
        styleLink.id = "style-link-sort";
        styleLink.rel = "stylesheet";
        styleLink.href = cssUrl;
        styleLink.type = "text/css";
        sortPopover.shadowRoot.appendChild(styleLink);
      }
      return true;
    }
    return false;
  };

  let attempts = 0;
  const intervalId = setInterval(() => {
    attempts++;
    if (inject() || attempts >= 100) {
      clearInterval(intervalId);
    }
  }, 100);

  document.addEventListener('shopify:section:load', inject);
  document.addEventListener('shopify:theme:editor:load', inject);
})();
/* Cushion Color Drawer Height Fix */
(function() {
  const updateDrawerHeights = () => {
    const cushionDrawers = document.querySelectorAll('cushion-color-drawer');
    
    cushionDrawers.forEach(cushionDrawer => {
      const drawer = cushionDrawer.closest('x-drawer');
      const stickyHeader = cushionDrawer.querySelector('.drawer-sticky-header');

      if (drawer && stickyHeader) {
        let themeHeaderHeight = 0;
        if (drawer.shadowRoot) {
          const partHeader = drawer.shadowRoot.querySelector('[part="header"]');
          if (partHeader) themeHeaderHeight = partHeader.offsetHeight || partHeader.getBoundingClientRect().height;
        }

        const stickyHeight = stickyHeader.offsetHeight || stickyHeader.getBoundingClientRect().height;
        const totalToSubtract = themeHeaderHeight + stickyHeight;

        if (totalToSubtract > 0) {
          document.documentElement.style.setProperty('--header-total-height', `${totalToSubtract}px`);
        }
      }
    });
  };

  window.addEventListener('resize', updateDrawerHeights);
  document.addEventListener('dialog:after-show', (e) => {
    if (e.target.id && e.target.id.includes('cushion-color-drawer')) {
      setTimeout(updateDrawerHeights, 100);
    }
  });
  window.addEventListener('load', updateDrawerHeights);
})();





(function() {
  const updateAccordionHeight = () => {
    const accordion = document.getElementById('facets-accordion');
    const inner = accordion?.querySelector('.facets-accordion-inner');
    if (accordion && inner) {
      // If we are closed, we need to temporarily enable measurement
      const isOpen = accordion.classList.contains('is-open');
      if (!isOpen) {
        accordion.style.display = 'block';
        accordion.style.visibility = 'hidden';
        accordion.style.height = 'auto';
      }

      const height = inner.scrollHeight || inner.offsetHeight;

      if (!isOpen) {
        accordion.style.display = '';
        accordion.style.visibility = '';
        accordion.style.height = '';
      }

      const rect = accordion.getBoundingClientRect();
      const availableHeight = window.innerHeight - rect.top;
      const contentHeight = inner.scrollHeight || inner.offsetHeight;

      // If content height exceeds available space (touches bottom), cap it and enable scroll
      if (contentHeight >= availableHeight && contentHeight > 0) {
        accordion.style.setProperty('--accordion-height', 'calc(100dvh - 250px)');
        accordion.style.overflowY = 'auto';
      } else {
        accordion.style.setProperty('--accordion-height', contentHeight + 'px');
        accordion.style.overflowY = 'hidden';
      }
    }
  };

  const initSync = () => {
    if (window.facetsSyncInitialized) return;
    
    // Use capture phase to ensure we catch events before theme components stop them
    window.addEventListener('click', (event) => {
      const filterBtn = event.target.closest('[aria-controls="facets-accordion"]');
      const drawerBtn = event.target.closest('[aria-controls="facets-drawer"]');
      const sortBtn = event.target.closest('[aria-controls="sort-by-popover"]');

      // Always fetch latest elements from DOM because they might have been replaced via AJAX
      const accordion = document.getElementById('facets-accordion');
      const drawer = document.getElementById('facets-drawer');
      const sortPopover = document.getElementById('sort-by-popover');

      // 1. CLICK OUTSIDE TO CLOSE
      if (accordion && accordion.classList.contains('is-open')) {
        const isClickInside = accordion.contains(event.target);
        if (!isClickInside && !filterBtn && !drawerBtn && !sortBtn) {
          accordion.classList.remove('is-open');
          const activeFilterBtn = document.querySelector('[aria-controls="facets-accordion"]');
          if (activeFilterBtn) activeFilterBtn.setAttribute('aria-expanded', 'false');
          const wrapper = accordion.closest('.collection-filter_bar_with_accordian');
          if (wrapper) wrapper.classList.remove('facets-is-open');
        }
      }

      // 2. MUTUAL EXCLUSIVITY (Clicking Sort or Drawer closes Accordion)
      if (sortBtn || drawerBtn) {
        if (accordion && accordion.classList.contains('is-open')) {
          accordion.classList.remove('is-open');
          const activeFilterBtn = document.querySelector('[aria-controls="facets-accordion"]');
          if (activeFilterBtn) activeFilterBtn.setAttribute('aria-expanded', 'false');
          const wrapper = accordion.closest('.collection-filter_bar_with_accordian');
          if (wrapper) wrapper.classList.remove('facets-is-open');
        }
      }

      // 3. ACCORDION TOGGLE (Clicking Filter button)
      if (filterBtn) {
        // We handle accordion toggle manually
        const isExpanded = filterBtn.getAttribute('aria-expanded') === 'true';
        const isOpening = !isExpanded;

        if (isOpening) {
          if (sortPopover && sortPopover.hasAttribute('open')) sortPopover.removeAttribute('open');
          if (drawer && drawer.hasAttribute('open')) drawer.removeAttribute('open');
        }

        filterBtn.setAttribute('aria-expanded', isOpening);
        if (accordion) {
          if (isOpening) {
            updateAccordionHeight();
          }
          accordion.classList.toggle('is-open', isOpening);
          if (isOpening) {
            setTimeout(updateAccordionHeight, 10); // Small delay to ensure styles are applied
          }
        }
        const wrapper = accordion?.closest('.collection-filter_bar_with_accordian');
        if (wrapper) wrapper.classList.toggle('facets-is-open', isOpening);

        // Prevent default behavior to avoid multiple toggles if the theme has other listeners
        event.preventDefault();
      }
    }, { capture: true });

    // Persistence for Sort Popover on resize (still needed if layout changes)
    let wasMobile = window.innerWidth < 1000;
    window.addEventListener('resize', () => {
      const isMobile = window.innerWidth < 1000;
      if (isMobile !== wasMobile) {
        const sortPopover = document.getElementById('sort-by-popover');
        if (sortPopover && sortPopover.hasAttribute('open')) sortPopover.removeAttribute('open');
        wasMobile = isMobile;
      }
    });
    window.addEventListener('resize', updateAccordionHeight);
    window.addEventListener('load', updateAccordionHeight);
    document.addEventListener('shopify:section:load', () => {
      setTimeout(updateAccordionHeight, 100);
    });

    window.facetsSyncInitialized = true;
  };

  initSync();
  document.addEventListener('shopify:section:load', initSync);
})();

// Get combined header and announcement bar height for sticky elements
(function() {
  const updateHeaderHeight = () => {
    const header = document.querySelector('.shopify-section--header');
    const announcement = document.querySelector('.shopify-section--announcement-bar');
    
    let totalHeight = 0;
    if (header) totalHeight += header.getBoundingClientRect().height;
    if (announcement) totalHeight += announcement.getBoundingClientRect().height;
    
    if (totalHeight > 0) {
      document.documentElement.style.setProperty('--header-height-custom', (totalHeight) + 'px');
    }
  };

  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('load', updateHeaderHeight);

  updateHeaderHeight();
  
  document.addEventListener('shopify:section:load', updateHeaderHeight);
})();

/* Dynamic PDP Gradient Height Calculation */
(function() {
  const updatePdpGradientHeight = () => {
    // Only target desktop screens (min-width: 1000px) as per the design
    if (window.innerWidth < 1000) return;

    const parent = document.querySelector('.custom-bg_for_mobile');
    const breadcrumb = document.querySelector('.breadcrumb');
    const content = document.querySelector('.js_find_height');
    
    if (!content || !parent) return;
    
    // 1. Get padding-top of the main section
    const paddingTop = parseFloat(getComputedStyle(parent).paddingTop) || 0;
    
    // 2. Get height of the breadcrumb including margin
    let breadcrumbH = 0;
    if (breadcrumb && getComputedStyle(breadcrumb).display !== 'none') {
      const style = getComputedStyle(breadcrumb);
      breadcrumbH = breadcrumb.offsetHeight + parseFloat(style.marginBottom || 0);
    }
    
    // Calculate total top offset (padding + breadcrumb)
    const totalTop = paddingTop + breadcrumbH;
    
    // 3. Calculate total height (top offset + main content height)
    const totalHeight = content.offsetHeight + totalTop;
    
    // Inject or update a style tag to override the hardcoded PDP gradient height
    let styleTag = document.getElementById('pdp-dynamic-gradient-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'pdp-dynamic-gradient-style';
      document.head.appendChild(styleTag);
    }
    
    // Update the height and top properties of the pseudo-element
    styleTag.innerHTML = `
      @media screen and (min-width: 1000px) {
        .apply_before_gradiant .desktop_custom_gradiant:before {
          height: ${totalHeight}px !important;
          top: -${totalTop + 10}px !important;
          display: block !important;
        }
      }
    `;
  };

  // Run on load and window resize
  window.addEventListener('resize', updatePdpGradientHeight);
  window.addEventListener('load', updatePdpGradientHeight);
  
  // Initial run
  updatePdpGradientHeight();
  
  // Run after variants might have changed content height or sections are reloaded in the editor
  document.addEventListener('shopify:section:load', () => {
    setTimeout(updatePdpGradientHeight, 100);
  });
  
  // Extra checks for late-loading images or content
  setTimeout(updatePdpGradientHeight, 500);
  setTimeout(updatePdpGradientHeight, 2000);
})();

            

  // Injection for product-pop-up shadow root
  (function() {
    const inject = () => {
      const productPopup = document.querySelector('#product-pop-up');
      if (productPopup && productPopup.shadowRoot) {
        const cssUrl = productPopup.getAttribute('data-shadow-css');
        if (cssUrl && !productPopup.shadowRoot.querySelector('#style-link-product-popup')) {
          const styleLink = document.createElement('link');
          styleLink.id = "style-link-product-popup";
          styleLink.rel = "stylesheet";
          styleLink.href = cssUrl;
          styleLink.type = "text/css";
          productPopup.shadowRoot.appendChild(styleLink);
        }
        return true;
      }
      return false;
    };

    let attempts = 0;
    const intervalId = setInterval(() => {
      attempts++;
      if (inject() || attempts >= 100) {
        clearInterval(intervalId);
      }
    }, 100);

    document.addEventListener('shopify:section:load', inject);
    document.addEventListener('shopify:theme:editor:load', inject);
  })();


  document.addEventListener("click", function(e) {
    const chooseBtn = e.target.closest(".js-choose-fabric-variants");
    if (chooseBtn) {
      const buyButton = document.querySelector('.js-buy-button button');
      if (buyButton) {
        // Small delay to ensure any parallel selection logic has processed
        setTimeout(() => {
          buyButton.click();
        }, 100);
      }
    }
  });